import type { Header } from "@tanstack/react-table";

interface DataTableColumnResizerProps<TData> {
  header: Header<TData, unknown>;
}

export function DataTableColumnResizer<T>({ header }: DataTableColumnResizerProps<T>) {
  if (!header.column.getCanResize()) return <></>;

  return (
    <div
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      onDoubleClick={() => {
        header.column.resetSize();
      }}
      className="group absolute top-1/4 right-0 h-1/2 cursor-col-resize touch-none rounded-full px-1 select-none"
    >
      <div className="h-full w-0.5 rounded-full bg-border group-hover:bg-primary" />
    </div>
  );
}
